import { render, staticRenderFns } from "./Turismo5Form.vue?vue&type=template&id=b38066a4&scoped=true&"
import script from "./Turismo5Form.vue?vue&type=script&lang=js&"
export * from "./Turismo5Form.vue?vue&type=script&lang=js&"
import style0 from "./Turismo5Form.vue?vue&type=style&index=0&id=b38066a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38066a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VRow,VTextField})
